export { default } from './InventoryTypeFilter'
